// const fakes = require('./result.json');
const getRequestType = require('./sendSearchRequest/getRequestType');
const getQueryName = require('./sendSearchRequest/getQueryName');
const { sendRequest } = require('core');
const { queryParser } = require('gui');

module.exports = function sendSearchRequest(query = '', type = 'sendersReference') {
	const queryId = queryParser.get('id');
	const urlQuery = queryParser.get('traceNo');

	if(window.history && urlQuery !== query)
		window.history.pushState({}, "Transportsiden", `?traceNo=${query}&id=${queryId}`);
    // return new Promise((resolve,reject) => {
    //     setTimeout(() => resolve(fakes[0].Result), Math.random()*0);
    // });
    return sendRequest([{
        __Type: getRequestType(type),
        [getQueryName(type)]: query
    }])
    .then(responses => responses[0].Result);
};
